import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'agent' | 'supervisor' | 'admin'
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, currentAgent } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    // Preserve the intended destination (e.g. a deep link from a team email
    // landing on /tickets/:id) so the login page can return the user there
    // after they authenticate. The path alone carries no token and exposes
    // no data until the user is logged in.
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (requiredRole && currentAgent?.role !== requiredRole && currentAgent?.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
